import {
  DropdownOption,
  ExpenseCategory,
  Merchant,
  Project,
  ExpenseGroup,
} from './types';

export const mapExpenseCategory = (
  category: ExpenseCategory,
): DropdownOption => ({
  label: category.Name,
  value: category.Id,
});

export const mapMerchant = (merchant: Merchant): DropdownOption => ({
  label: merchant.Name,
  value: merchant.Id,
});

export const mapProject = (project: Project): DropdownOption => ({
  label: project.flair__Name__c,
  value: project.Id,
});

export const mapExpenseGroup = (
  expenseGroup: ExpenseGroup,
): DropdownOption => ({
  label: expenseGroup.Name,
  value: expenseGroup.Id,
});
